export default __webpack_public_path__ + "static/media/wallet-phone.ff66a684.png";